import {observer} from 'mobx-react';
import {useMap} from '@vis.gl/react-google-maps';
import {useEffect, useRef} from 'react';

const RadiusCircle = observer(({coords, radius, fillColor = '#54C379', strokeColor = '#54C379'}) => {
  const circleRef = useRef(null);
  const map = useMap();

  useEffect(() => {
    if (!coords) {
      removeCircle();
      return;
    }

    circleRef.current ||= new window.google.maps.Circle({
      map,
      clickable: false,
      radius,
      fillColor,
      fillOpacity: 0.2,
      strokeColor,
      strokeOpacity: 0.5,
      strokeWeight: 1
    });

    circleRef.current.setCenter(coords);

    return removeCircle;
  }, [coords, fillColor, strokeColor]);

  function removeCircle() {
    if (!circleRef.current) return;

    circleRef.current.setMap(null);
    circleRef.current = null;
  }

  return null;
});

export default RadiusCircle;
